export default "__VITE_ASSET__B8tjTPX9__"